import { useEffect } from 'react';
import { Button, Dialog, Flex, Text, TextInput, createForm } from '@applyboard/crystal-ui';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field,
  useSetFieldValues = _createForm.useSetFieldValues,
  useFieldValues = _createForm.useFieldValues;
function TextInputComponent(_ref) {
  var label = _ref.label,
    value = _ref.value,
    helpText = _ref.helpText;
  var setFieldValues = useSetFieldValues();
  var fieldValue = useFieldValues();
  useEffect(function () {
    setFieldValues({
      adminComment: value
    });
  }, [setFieldValues, value]);
  var handleChange = function handleChange(val) {
    setFieldValues({
      adminComment: val
    });
  };
  return _jsx(TextInput, {
    label: label,
    onChange: handleChange,
    helpText: helpText,
    value: fieldValue.adminComment
  });
}
export function KycAdminDialogs(_ref2) {
  var heading = _ref2.heading,
    contentText = _ref2.contentText,
    submitButtonText = _ref2.submitButtonText,
    isKycAdminDialogOpen = _ref2.isKycAdminDialogOpen,
    closeAdminDialog = _ref2.closeAdminDialog,
    handleSubmit = _ref2.handleSubmit,
    fieldLabel = _ref2.fieldLabel,
    helpText = _ref2.helpText,
    _ref2$initialInputVal = _ref2.initialInputValue,
    initialInputValue = _ref2$initialInputVal === void 0 ? '' : _ref2$initialInputVal,
    _ref2$isCommentOption = _ref2.isCommentOptional,
    isCommentOptional = _ref2$isCommentOption === void 0 ? true : _ref2$isCommentOption;
  return _jsxs(Dialog, {
    open: isKycAdminDialogOpen,
    size: "md",
    onOpenChange: function onOpenChange() {
      closeAdminDialog();
    },
    children: [_jsx(Dialog.Heading, {
      children: heading
    }), _jsx(Dialog.Content, {
      children: _jsx(Form, {
        onSubmit: function onSubmit(data) {
          if (!isCommentOptional && data.adminComment === '') return;
          handleSubmit(data);
        },
        defaultValues: {
          adminComment: ''
        },
        id: "admin-comment-dialog",
        children: _jsxs(Flex, {
          direction: "column",
          gap: 4,
          children: [_jsx(Text, {
            children: contentText
          }), _jsx(Field, {
            as: function as() {
              return _jsx(TextInputComponent, {
                value: initialInputValue !== null && initialInputValue !== void 0 ? initialInputValue : '',
                label: fieldLabel,
                helpText: helpText
              });
            },
            name: "adminComment",
            label: fieldLabel
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        type: "submit",
        form: "admin-comment-dialog",
        intent: "primary",
        width: "fill",
        children: submitButtonText
      })]
    })]
  });
}